module.exports = __webpack_public_path__ + "assets/media/day32.f735fc9b.mp3";